// extracted by mini-css-extract-plugin
module.exports = {"container":"ManageMenu_container__1LIL7","createBlock":"ManageMenu_createBlock__2YU99"};